// src/components/StarRating.jsx
import React from 'react';
import { Star } from 'lucide-react';

function StarRating({ value, onChange, readOnly = false, size = 5 }) {
  const rating = typeof value === 'string' ? parseInt(value) : (value || 0);

  const handleClick = (newValue) => {
    if (!readOnly && onChange) {
      onChange(newValue);
    }
  };


  return (
    <div className="flex items-center gap-1">
      {[...Array(size)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= rating;
        
        return (
          <button
            key={index}
            type="button"
            onClick={() => handleClick(starValue)}
            disabled={readOnly}
            className={`transition-colors ${
              readOnly ? 'cursor-default' : 'cursor-pointer hover:scale-110'
            }`}
            aria-label={`Rate ${starValue} out of ${size}`}
            aria-pressed={isFilled}
          >
            <Star
              className={`w-5 h-5 ${
                isFilled
                  ? 'fill-yellow-400 text-yellow-400'
                  : 'fill-gray-300 text-gray-300 dark:fill-gray-600 dark:text-gray-600'
              } transition-colors`}
            />
          </button>
        );
      })}
      {!readOnly && (
        <span className="ml-2 text-sm text-gray-600 dark:text-gray-400">
          {rating > 0 ? `${rating}/${size}` : 'Not rated'}
        </span>
      )}
    </div>
  );
}

export default StarRating;

